import Profile from './Profile.component';

export default Profile;
